module.exports = __webpack_public_path__ + "static/cnef-66471d840d9300b7e2a2d5b324517336.jpg";